import { useState } from "react";
import { ArrowLeft, Moon, Sun, Bell, Globe, Shield, Save } from "lucide-react";
import { Link } from "react-router-dom";
import styles from "./Preferences.module.css";

const Preferences = () => {
  const [preferences, setPreferences] = useState({
    theme: "light",
    language: "en",
    emailNotifications: true,
    pushNotifications: false,
    weeklyReports: true,
    autoSave: true,
    twoFactorAuth: false,
  });

  const handleToggle = (key) => {
    setPreferences({
      ...preferences,
      [key]: !preferences[key],
    });
  };

  const handleSelect = (key, value) => {
    setPreferences({
      ...preferences,
      [key]: value,
    });
  };

  const handleSave = () => {
    console.log("Preferences saved:", preferences);
    alert("Preferences saved successfully!");
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <Link to="/file-manager" className={styles.backButton}>
          <ArrowLeft size={20} />
          Back to File Manager
        </Link>
        <h1 className={styles.title}>Preferences</h1>
      </div>

      <div className={styles.content}>
        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionIcon}>
              <Sun size={20} />
            </div>
            <h2 className={styles.sectionTitle}>Appearance</h2>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>Theme</label>
              <p className={styles.preferenceDescription}>
                Choose your preferred color scheme
              </p>
            </div>
            <div className={styles.themeSelector}>
              <button
                className={`${styles.themeButton} ${
                  preferences.theme === "light" ? styles.themeButtonActive : ""
                }`}
                onClick={() => handleSelect("theme", "light")}
              >
                <Sun size={18} />
                Light
              </button>
              <button
                className={`${styles.themeButton} ${
                  preferences.theme === "dark" ? styles.themeButtonActive : ""
                }`}
                onClick={() => handleSelect("theme", "dark")}
              >
                <Moon size={18} />
                Dark
              </button>
            </div>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionIcon}>
              <Globe size={20} />
            </div>
            <h2 className={styles.sectionTitle}>Language & Region</h2>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>Language</label>
              <p className={styles.preferenceDescription}>
                Select your preferred language
              </p>
            </div>
            <select
              className={styles.select}
              value={preferences.language}
              onChange={(e) => handleSelect("language", e.target.value)}
            >
              <option value="en">English</option>
              <option value="hy">Armenian</option>
              <option value="ru">Russian</option>
              <option value="es">Spanish</option>
            </select>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionIcon}>
              <Bell size={20} />
            </div>
            <h2 className={styles.sectionTitle}>Notifications</h2>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>
                Email Notifications
              </label>
              <p className={styles.preferenceDescription}>
                Receive notifications via email
              </p>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={preferences.emailNotifications}
                onChange={() => handleToggle("emailNotifications")}
              />
              <span className={styles.toggleSlider}></span>
            </label>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>
                Push Notifications
              </label>
              <p className={styles.preferenceDescription}>
                Receive push notifications in browser
              </p>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={preferences.pushNotifications}
                onChange={() => handleToggle("pushNotifications")}
              />
              <span className={styles.toggleSlider}></span>
            </label>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>Weekly Reports</label>
              <p className={styles.preferenceDescription}>
                Receive weekly activity reports
              </p>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={preferences.weeklyReports}
                onChange={() => handleToggle("weeklyReports")}
              />
              <span className={styles.toggleSlider}></span>
            </label>
          </div>
        </div>

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <div className={styles.sectionIcon}>
              <Shield size={20} />
            </div>
            <h2 className={styles.sectionTitle}>Security</h2>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>Auto-save</label>
              <p className={styles.preferenceDescription}>
                Automatically save your work
              </p>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={preferences.autoSave}
                onChange={() => handleToggle("autoSave")}
              />
              <span className={styles.toggleSlider}></span>
            </label>
          </div>

          <div className={styles.preference}>
            <div className={styles.preferenceInfo}>
              <label className={styles.preferenceLabel}>
                Two-Factor Authentication
              </label>
              <p className={styles.preferenceDescription}>
                Add an extra layer of security
              </p>
            </div>
            <label className={styles.toggle}>
              <input
                type="checkbox"
                checked={preferences.twoFactorAuth}
                onChange={() => handleToggle("twoFactorAuth")}
              />
              <span className={styles.toggleSlider}></span>
            </label>
          </div>
        </div>

        <button className={styles.saveButton} onClick={handleSave}>
          <Save size={18} />
          Save Preferences
        </button>
      </div>
    </div>
  );
};

export default Preferences;
